import { useMemo } from "react";
import { useAuth } from "../../context/AuthContext";

const normalizePermission = (permission) => `${permission || ""}`.trim();

export const usePermissions = () => {
  const { userData } = useAuth();

  const permissions = useMemo(
    () => (Array.isArray(userData?.permissions) ? userData.permissions.map(normalizePermission) : []),
    [userData?.permissions]
  );

  const hasWildcard = permissions.includes("*");

  const can = (permission) => {
    const normalized = normalizePermission(permission);
    return Boolean(normalized) && (hasWildcard || permissions.includes(normalized));
  };

  const canAny = (permissionList = []) => permissionList.some((permission) => can(permission));
  const canAll = (permissionList = []) => permissionList.every((permission) => can(permission));

  return {
    permissions,
    can,
    canAny,
    canAll
  };
};

export default usePermissions;
